import { Color } from "../../maths/Color";
export class SpineEmptyRender {
    getSpineColor() {
        return Color.WHITE;
    }
    changeSkeleton(skeleton) {
    }
    init(skeleton, templet, renderNode, state) {
    }
    play(animationName) {
    }
    render(time) {
    }
    setSkinIndex(index) {
    }
    initBake(obj) {
    }
    destroy() {
    }
}
SpineEmptyRender.instance = new SpineEmptyRender();
